import React from 'react';
import { Star } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Carousel } from './ui/Carousel';

/**
 * Replace with verified testimonials only. Nothing here should be
 * invented — edit the text, name and role in place as reviews come in.
 */
const TESTIMONIALS = [{
  name: 'Carolina R.',
  role: 'Estudiante avanzada',
  text: 'El mapa de pruebas me cambió la forma de trabajar. Antes elegía tests al azar; ahora sé cuál usar y por qué.'
}, {
  name: 'Matías L.',
  role: 'Kinesiólogo junior',
  text: 'El tomo de casos clínicos es lo que me faltaba para conectar la evaluación con el diagnóstico funcional.'
}, {
  name: 'Pablo A.',
  role: 'Recién graduado',
  text: 'El diccionario de pruebas me ayudó a entender para qué sirve cada maniobra. Antes las memorizaba; ahora las entiendo.'
}];
function TestimonialCard({
  t
}: {
  t: (typeof TESTIMONIALS)[number];
}) {
  return <figure className="h-full bg-white border border-navy-900/10 rounded-xl p-3.5 sm:p-4 flex flex-col shadow-[0_2px_10px_rgba(11,27,51,0.05)]" data-id="element-213" data-mp="q893vso07bkl">
      <div className="flex gap-0.5 mb-2" data-id="element-214" data-mp="m5kngsk6j1ej">
        {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-gold text-gold" data-id="element-215" data-mp="780ivmr7388w" data-mpi={i} />)}
      </div>
      <blockquote className="text-[12.5px] sm:text-[13.5px] text-navy-800/80 leading-relaxed mb-3" data-id="element-216" data-mp="c6vddlyiyl8u">
        “{t.text}”
      </blockquote>
      <figcaption className="flex items-center gap-2 mt-auto pt-2.5 border-t border-navy-900/10" data-id="element-217" data-mp="zxh86bjiq90w">
        <span className="w-7 h-7 rounded-full bg-navy-900 flex items-center justify-center text-gold font-bold font-heading text-[12px] flex-shrink-0" data-id="element-218" data-mp="14uhemnka5dsj">
          {t.name.charAt(0)}
        </span>
        <span className="min-w-0" data-id="element-219" data-mp="v4xz9rvs022f">
          <span className="block font-bold text-navy-950 text-[12.5px] leading-tight truncate" data-id="element-220" data-mp="v3wm9hv795i2">
            {t.name}
          </span>
          <span className="block text-[11px] text-navy-800/60 truncate" data-id="element-221" data-mp="1nlqq32dm2cmr">
            {t.role}
          </span>
        </span>
      </figcaption>
    </figure>;
}
export function Testimonials() {
  return <AnimatedSection className="relative bg-white py-9 sm:py-12 overflow-hidden" data-id="element-222" data-mp="1sj5x3n93x54i">
      <div aria-hidden className="pointer-events-none absolute -top-24 -left-20 w-[280px] h-[280px] rounded-full bg-steel/[0.07] blur-3xl" data-id="element-223" data-mp="1ohav0gjcqnpo" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224" data-mp="1jhpuw2sg49bd">
        <h2 className="font-heading text-navy-950 tracking-tight text-[1.2rem] sm:text-[1.8rem] leading-[1.16] max-w-xl mb-4 sm:mb-6" data-id="element-225" data-mp="1ejepq5d3imzh">
          <span className="font-extrabold" data-id="element-226" data-mp="19r3ngvuvup3r">Estudiantes y profesionales</span>{' '}
          <span className="font-editorial italic text-gold-deep font-medium" data-id="element-227" data-mp="14u4re7rns82x">
            que ya utilizan Atlas Clínico.
          </span>
        </h2>
      </div>

      {/* Mobile: carousel */}
      <div className="sm:hidden" data-id="element-228" data-mp="vrc2gb5y88g9">
        <Carousel label="Testimonios" count={TESTIMONIALS.length} className="pl-4 text-navy-950" data-id="element-229" data-mp="vuq7jr5zyvre">
          {TESTIMONIALS.map(t => <div key={t.name} data-carousel-card className="snap-start flex-shrink-0 w-[80vw] max-w-[300px]" data-id="element-230" data-mp="32gdzovdiirtf">
              <TestimonialCard t={t} data-id="element-231" data-mp="3cetvhbnhip99" />
            </div>)}
          <span aria-hidden className="flex-shrink-0 w-1" data-id="element-232" data-mp="3ggosi3ydugh8" />
        </Carousel>
      </div>

      {/* Desktop */}
      <div className="hidden sm:block max-w-5xl mx-auto px-6 lg:px-8" data-id="element-233" data-mp="2jqo96kgs8s7b">
        <div className="grid grid-cols-3 gap-3" data-id="element-234" data-mp="2jobk7nclxhkr">
          {TESTIMONIALS.map(t => <TestimonialCard key={t.name} t={t} data-id="element-235" data-mp="2opr61hmlzs47" />)}
        </div>
      </div>
    </AnimatedSection>;
}